module.exports = {
  "common.color.transparent": "--commonColorTransparent",
  "common.color.white": "--commonColorWhite",
  "common.color.black": "--commonColorBlack",
  "common.dimension.container.narrow": "--commonDimensionContainerNarrow",
  "common.dimension.container": "--commonDimensionContainer",
  "common.dimension.container.wide": "--commonDimensionContainerWide",
  "common.dimension.breakpoint.xs": "--commonDimensionBreakpointXs",
  "common.dimension.breakpoint.mini": "--commonDimensionBreakpointMini",
  "common.dimension.breakpoint.sm": "--commonDimensionBreakpointSm",
  "common.dimension.breakpoint.md": "--commonDimensionBreakpointMd",
  "common.dimension.breakpoint.lg": "--commonDimensionBreakpointLg",
  "common.dimension.breakpoint.xl": "--commonDimensionBreakpointXl",
  "common.dimension.breakpoint.xxl": "--commonDimensionBreakpointXxl",
  "common.dimension.breakpoint.xxxl": "--commonDimensionBreakpointXxxl",
  "common.dimension.spacing.0": "--commonDimensionSpacing0",
  "common.dimension.spacing.1": "--commonDimensionSpacing1",
  "common.dimension.spacing.2": "--commonDimensionSpacing2",
  "common.dimension.spacing.3": "--commonDimensionSpacing3",
  "common.dimension.spacing.4": "--commonDimensionSpacing4",
  "common.dimension.spacing.5": "--commonDimensionSpacing5",
  "common.dimension.spacing.6": "--commonDimensionSpacing6",
  "common.dimension.spacing.7": "--commonDimensionSpacing7",
  "common.dimension.spacing.8": "--commonDimensionSpacing8",
  "common.dimension.spacing.9": "--commonDimensionSpacing9",
  "common.dimension.spacing.10": "--commonDimensionSpacing10",
  "alert.color.bg.success": "--alertColorBgSuccess",
  "alert.color.bg.error": "--alertColorBgError",
  "alert.color.bg.warning": "--alertColorBgWarning",
  "alert.color.bg.info": "--alertColorBgInfo",
  "button.color.bg.primary": "--buttonColorBgPrimary",
  "button.color.bg.primary.hover": "--buttonColorBgPrimaryHover",
  "button.color.bg.primary.active": "--buttonColorBgPrimaryActive",
  "button.color.bg.primary.disabled": "--buttonColorBgPrimaryDisabled",
  "button.color.bg.secondary": "--buttonColorBgSecondary",
  "button.color.bg.secondary.hover": "--buttonColorBgSecondaryHover",
  "button.color.bg.secondary.active": "--buttonColorBgSecondaryActive",
  "button.color.bg.secondary.disabled": "--buttonColorBgSecondaryDisabled",
  "button.color.bg.tertiary": "--buttonColorBgTertiary",
  "button.color.bg.tertiary.hover": "--buttonColorBgTertiaryHover",
  "button.color.bg.tertiary.active": "--buttonColorBgTertiaryActive",
  "button.color.bg.tertiary.disabled": "--buttonColorBgTertiaryDisabled",
  "button.color.bg.destructive": "--buttonColorBgDestructive",
  "button.color.bg.destructive.hover": "--buttonColorBgDestructiveHover",
  "button.color.bg.destructive.active": "--buttonColorBgDestructiveActive",
  "button.color.bg.destructive.disabled": "--buttonColorBgDestructiveDisabled",
  "button.color.fg.primary": "--buttonColorFgPrimary",
  "button.color.fg.primary.hover": "--buttonColorFgPrimaryHover",
  "button.color.fg.primary.active": "--buttonColorFgPrimaryActive",
  "button.color.fg.primary.disabled": "--buttonColorFgPrimaryDisabled",
  "button.color.fg.secondary": "--buttonColorFgSecondary",
  "button.color.fg.secondary.hover": "--buttonColorFgSecondaryHover",
  "button.color.fg.secondary.active": "--buttonColorFgSecondaryActive",
  "button.color.fg.secondary.disabled": "--buttonColorFgSecondaryDisabled",
  "button.color.fg.tertiary": "--buttonColorFgTertiary",
  "button.color.fg.tertiary.hover": "--buttonColorFgTertiaryHover",
  "button.color.fg.tertiary.active": "--buttonColorFgTertiaryActive",
  "button.color.fg.tertiary.disabled": "--buttonColorFgTertiaryDisabled",
  "button.color.fg.destructive": "--buttonColorFgDestructive",
  "button.color.fg.destructive.hover": "--buttonColorFgDestructiveHover",
  "button.color.fg.destructive.active": "--buttonColorFgDestructiveActive",
  "button.color.fg.destructive.disabled": "--buttonColorFgDestructiveDisabled",
  "button.color.border.primary": "--buttonColorBorderPrimary",
  "button.color.border.primary.hover": "--buttonColorBorderPrimaryHover",
  "button.color.border.primary.active": "--buttonColorBorderPrimaryActive",
  "button.color.border.primary.disabled": "--buttonColorBorderPrimaryDisabled",
  "button.color.border.secondary": "--buttonColorBorderSecondary",
  "button.color.border.secondary.hover": "--buttonColorBorderSecondaryHover",
  "button.color.border.secondary.active": "--buttonColorBorderSecondaryActive",
  "button.color.border.secondary.disabled": "--buttonColorBorderSecondaryDisabled",
  "button.color.border.tertiary": "--buttonColorBorderTertiary",
  "button.color.border.tertiary.hover": "--buttonColorBorderTertiaryHover",
  "button.color.border.tertiary.active": "--buttonColorBorderTertiaryActive",
  "button.color.border.tertiary.disabled": "--buttonColorBorderTertiaryDisabled",
  "button.color.border.destructive": "--buttonColorBorderDestructive",
  "button.color.border.destructive.hover": "--buttonColorBorderDestructiveHover",
  "button.color.border.destructive.active": "--buttonColorBorderDestructiveActive",
  "button.color.border.destructive.disabled": "--buttonColorBorderDestructiveDisabled",
  "button.dimension.border.radius": "--buttonDimensionBorderRadius",
  "button.dimension.border.width": "--buttonDimensionBorderWidth",
  "button.dimension.padding.horizontal": "--buttonDimensionPaddingHorizontal",
  "button.dimension.padding.vertical": "--buttonDimensionPaddingVertical",
  "button.dimension.padding.gap": "--buttonDimensionPaddingGap",
  "button.dimension.padding.small.horizontal": "--buttonDimensionPaddingSmallHorizontal",
  "button.dimension.padding.small.vertical": "--buttonDimensionPaddingSmallVertical",
  "button.dimension.padding.small.gap": "--buttonDimensionPaddingSmallGap",
  "button.dimension.padding.large.horizontal": "--buttonDimensionPaddingLargeHorizontal",
  "button.dimension.padding.large.vertical": "--buttonDimensionPaddingLargeVertical",
  "button.dimension.padding.large.gap": "--buttonDimensionPaddingLargeGap",
  "button.typography.fontFamily": "--buttonTypographyFontFamily",
  "button.typography.fontSize": "--buttonTypographyFontSize",
  "button.typography.fontWeight": "--buttonTypographyFontWeight",
  "button.typography.lineHeight": "--buttonTypographyLineHeight",
  "button.typography.letterSpacing": "--buttonTypographyLetterSpacing",
  "button.typography.textTransform": "--buttonTypographyTextTransform",
  "button.typography.small.fontFamily": "--buttonTypographySmallFontFamily",
  "button.typography.small.fontSize": "--buttonTypographySmallFontSize",
  "button.typography.small.fontWeight": "--buttonTypographySmallFontWeight",
  "button.typography.small.lineHeight": "--buttonTypographySmallLineHeight",
  "button.typography.small.letterSpacing": "--buttonTypographySmallLetterSpacing",
  "button.typography.small.textTransform": "--buttonTypographySmallTextTransform",
  "button.typography.large.fontFamily": "--buttonTypographyLargeFontFamily",
  "button.typography.large.fontSize": "--buttonTypographyLargeFontSize",
  "button.typography.large.fontWeight": "--buttonTypographyLargeFontWeight",
  "button.typography.large.lineHeight": "--buttonTypographyLargeLineHeight",
  "button.typography.large.letterSpacing": "--buttonTypographyLargeLetterSpacing",
  "button.typography.large.textTransform": "--buttonTypographyLargeTextTransform",
  "datePicker.color.bg.selected": "--datePickerColorBgSelected",
  "datePicker.color.bg.selected.hover": "--datePickerColorBgSelectedHover",
  "datePicker.color.bg.hover": "--datePickerColorBgHover",
  "datePicker.color.fg.selected": "--datePickerColorFgSelected",
  "datePicker.color.fg.selected.hover": "--datePickerColorFgSelectedHover",
  "datePicker.color.fg.hover": "--datePickerColorFgHover",
  "drawer.color.bg": "--drawerColorBg",
  "drawer.color.bg.top": "--drawerColorBgTop",
  "drawer.color.fg.top": "--drawerColorFgTop",
  "drawer.color.fg.menu": "--drawerColorFgMenu",
  "drawer.color.fg.item": "--drawerColorFgItem",
  "drawer.color.fg.chevron": "--drawerColorFgChevron",
  "drawer.color.fg.close": "--drawerColorFgClose",
  "drawer.color.fg.link": "--drawerColorFgLink",
  "drawer.color.fg.link.hover": "--drawerColorFgLinkHover",
  "drawer.color.fg.link.pressed": "--drawerColorFgLinkPressed",
  "drawer.color.border.divider": "--drawerColorBorderDivider",
  "drawer.color.border.focus": "--drawerColorBorderFocus",
  "drawer.color.border.focus.top": "--drawerColorBorderFocusTop",
  "footer.color.bg": "--footerColorBg",
  "footer.color.bg.acknowledgement": "--footerColorBgAcknowledgement",
  "footer.color.fg": "--footerColorFg",
  "footer.color.fg.heading": "--footerColorFgHeading",
  "footer.color.fg.link": "--footerColorFgLink",
  "footer.color.fg.link.hover": "--footerColorFgLinkHover",
  "footer.color.fg.link.pressed": "--footerColorFgLinkPressed",
  "footer.color.fg.acknowledgement": "--footerColorFgAcknowledgement",
  "footer.color.border": "--footerColorBorder",
  "footer.color.border.focus": "--footerColorBorderFocus",
  "footer.color.border.focus.acknowledgement": "--footerColorBorderFocusAcknowledgement",
  "smallFooter.color.bg": "--smallFooterColorBg",
  "smallFooter.color.fg": "--smallFooterColorFg",
  "smallFooter.color.fg.link": "--smallFooterColorFgLink",
  "smallFooter.color.fg.link.hover": "--smallFooterColorFgLinkHover",
  "smallFooter.color.fg.link.pressed": "--smallFooterColorFgLinkPressed",
  "smallFooter.color.border.focus": "--smallFooterColorBorderFocus",
  "smallFooter.meta.acknowledgement.visible": "--smallFooterMetaAcknowledgementVisible",
  "smallFooter.meta.acknowledgement.showImage": "--smallFooterMetaAcknowledgementShowImage",
  "formControl.typography.label.fontFamily": "--formControlTypographyLabelFontFamily",
  "formControl.typography.label.fontSize": "--formControlTypographyLabelFontSize",
  "formControl.typography.label.fontWeight": "--formControlTypographyLabelFontWeight",
  "formControl.typography.label.lineHeight": "--formControlTypographyLabelLineHeight",
  "formControl.typography.label.letterSpacing": "--formControlTypographyLabelLetterSpacing",
  "formControl.typography.label.textTransform": "--formControlTypographyLabelTextTransform",
  "formControl.typography.help.fontFamily": "--formControlTypographyHelpFontFamily",
  "formControl.typography.help.fontSize": "--formControlTypographyHelpFontSize",
  "formControl.typography.help.fontWeight": "--formControlTypographyHelpFontWeight",
  "formControl.typography.help.lineHeight": "--formControlTypographyHelpLineHeight",
  "formControl.typography.help.letterSpacing": "--formControlTypographyHelpLetterSpacing",
  "header.color.bg.nav": "--headerColorBgNav",
  "header.color.fg.nav": "--headerColorFgNav",
  "header.color.fg.nav.hover": "--headerColorFgNavHover",
  "header.color.border.focus.nav": "--headerColorBorderFocusNav",
  "smallHeader.color.bg": "--smallHeaderColorBg",
  "smallHeader.color.bg.invert": "--smallHeaderColorBgInvert",
  "smallHeader.color.fg.menu": "--smallHeaderColorFgMenu",
  "smallHeader.color.fg.menu.invert": "--smallHeaderColorFgMenuInvert",
  "smallHeader.color.fg.icons": "--smallHeaderColorFgIcons",
  "smallHeader.color.fg.icons.invert": "--smallHeaderColorFgIconsInvert",
  "smallHeader.color.border.divider": "--smallHeaderColorBorderDivider",
  "smallHeader.color.border.divider.invert": "--smallHeaderColorBorderDividerInvert",
  "smallHeader.color.border.focus": "--smallHeaderColorBorderFocus",
  "smallHeader.color.border.focus.invert": "--smallHeaderColorBorderFocusInvert",
  "smallHeader.meta.isDark": "--smallHeaderMetaIsDark",
  "smallHeader.meta.isDark.invert": "--smallHeaderMetaIsDarkInvert",
  "input.color.bg": "--inputColorBg",
  "input.color.border": "--inputColorBorder",
  "loader.color.border.a": "--loaderColorBorderA",
  "loader.color.border.b": "--loaderColorBorderB",
  "overlay.color.bg": "--overlayColorBg",
  "productCard.color.bg.highlight": "--productCardColorBgHighlight",
  "productCard.color.fg.highlight": "--productCardColorFgHighlight",
  "progressStepper.color.fg.indicator.active": "--progressStepperColorFgIndicatorActive",
  "progressStepper.color.fg.indicator.inactive": "--progressStepperColorFgIndicatorInactive",
  "tag.color.bg": "--tagColorBg",
  "tag.color.bg.prominent": "--tagColorBgProminent",
  "tag.color.bg.gentle": "--tagColorBgGentle",
  "tag.color.bg.muted": "--tagColorBgMuted",
  "tag.color.bg.brand": "--tagColorBgBrand",
  "tag.color.bg.error": "--tagColorBgError",
  "tag.color.bg.success": "--tagColorBgSuccess",
  "tag.color.bg.warning": "--tagColorBgWarning",
  "tag.color.bg.info": "--tagColorBgInfo",
  "tag.color.fg": "--tagColorFg",
  "tag.color.fg.prominent": "--tagColorFgProminent",
  "tag.color.fg.gentle": "--tagColorFgGentle",
  "tag.color.fg.muted": "--tagColorFgMuted",
  "tag.color.fg.brand": "--tagColorFgBrand",
  "tag.color.fg.error": "--tagColorFgError",
  "tag.color.fg.success": "--tagColorFgSuccess",
  "tag.color.fg.warning": "--tagColorFgWarning",
  "tag.color.fg.info": "--tagColorFgInfo",
  "tag.typography.fontFamily": "--tagTypographyFontFamily",
  "tag.typography.fontSize": "--tagTypographyFontSize",
  "tag.typography.fontWeight": "--tagTypographyFontWeight",
  "tag.typography.lineHeight": "--tagTypographyLineHeight",
  "tag.typography.letterSpacing": "--tagTypographyLetterSpacing",
  "tag.typography.textTransform": "--tagTypographyTextTransform",
  "tooltip.color.bg": "--tooltipColorBg",
  "tooltip.color.fg": "--tooltipColorFg",
  "theme.color.bg": "--themeColorBg",
  "theme.color.bg.surface": "--themeColorBgSurface",
  "theme.color.bg.surface.prominent": "--themeColorBgSurfaceProminent",
  "theme.color.border": "--themeColorBorder",
  "theme.color.border.prominent": "--themeColorBorderProminent",
  "theme.color.border.gentle": "--themeColorBorderGentle",
  "theme.color.border.muted": "--themeColorBorderMuted",
  "theme.color.border.selected": "--themeColorBorderSelected",
  "theme.color.border.success": "--themeColorBorderSuccess",
  "theme.color.border.error": "--themeColorBorderError",
  "theme.color.border.warning": "--themeColorBorderWarning",
  "theme.color.border.info": "--themeColorBorderInfo",
  "theme.color.border.brand": "--themeColorBorderBrand",
  "theme.color.border.focus": "--themeColorBorderFocus",
  "theme.color.border.product.basic": "--themeColorBorderProductBasic",
  "theme.color.border.product.bronze": "--themeColorBorderProductBronze",
  "theme.color.border.product.silver": "--themeColorBorderProductSilver",
  "theme.color.border.product.gold": "--themeColorBorderProductGold",
  "theme.color.border.product.hospital": "--themeColorBorderProductHospital",
  "theme.color.border.product.extras": "--themeColorBorderProductExtras",
  "theme.color.border.product.combined": "--themeColorBorderProductCombined",
  "theme.color.fg": "--themeColorFg",
  "theme.color.fg.prominent": "--themeColorFgProminent",
  "theme.color.fg.gentle": "--themeColorFgGentle",
  "theme.color.fg.muted": "--themeColorFgMuted",
  "theme.color.fg.brand": "--themeColorFgBrand",
  "theme.color.fg.selected": "--themeColorFgSelected",
  "theme.color.fg.label": "--themeColorFgLabel",
  "theme.color.fg.success": "--themeColorFgSuccess",
  "theme.color.fg.error": "--themeColorFgError",
  "theme.color.fg.warning": "--themeColorFgWarning",
  "theme.color.fg.info": "--themeColorFgInfo",
  "theme.color.fg.heading.2xl": "--themeColorFgHeading2xl",
  "theme.color.fg.heading.xl": "--themeColorFgHeadingXl",
  "theme.color.fg.heading.lg": "--themeColorFgHeadingLg",
  "theme.color.fg.heading.md": "--themeColorFgHeadingMd",
  "theme.color.fg.heading.sm": "--themeColorFgHeadingSm",
  "theme.color.fg.heading.xs": "--themeColorFgHeadingXs",
  "theme.color.fg.link": "--themeColorFgLink",
  "theme.color.fg.link.hover": "--themeColorFgLinkHover",
  "theme.color.fg.link.active": "--themeColorFgLinkActive",
  "theme.color.fg.link.disabled": "--themeColorFgLinkDisabled",
  "theme.dimension.border.radius.none": "--themeDimensionBorderRadiusNone",
  "theme.dimension.border.radius.small": "--themeDimensionBorderRadiusSmall",
  "theme.dimension.border.radius.standard": "--themeDimensionBorderRadiusStandard",
  "theme.dimension.border.radius.full": "--themeDimensionBorderRadiusFull",
  "theme.dimension.border.width.none": "--themeDimensionBorderWidthNone",
  "theme.dimension.border.width.fine": "--themeDimensionBorderWidthFine",
  "theme.dimension.border.width.thin": "--themeDimensionBorderWidthThin",
  "theme.dimension.border.width.medium": "--themeDimensionBorderWidthMedium",
  "theme.dimension.border.width.thick": "--themeDimensionBorderWidthThick",
  "theme.meta.brand": "--themeMetaBrand",
  "theme.meta.modeName": "--themeMetaModeName",
  "theme.meta.isDark": "--themeMetaIsDark",
  "theme.typography.fontFamily.copy": "--themeTypographyFontFamilyCopy",
  "theme.typography.fontFamily.heading": "--themeTypographyFontFamilyHeading",
  "theme.typography.copy.fontFamily": "--themeTypographyCopyFontFamily",
  "theme.typography.copy.fontSize": "--themeTypographyCopyFontSize",
  "theme.typography.copy.fontWeight": "--themeTypographyCopyFontWeight",
  "theme.typography.copy.lineHeight": "--themeTypographyCopyLineHeight",
  "theme.typography.copy.letterSpacing": "--themeTypographyCopyLetterSpacing",
  "theme.typography.copy.small.fontFamily": "--themeTypographyCopySmallFontFamily",
  "theme.typography.copy.small.fontSize": "--themeTypographyCopySmallFontSize",
  "theme.typography.copy.small.fontWeight": "--themeTypographyCopySmallFontWeight",
  "theme.typography.copy.small.lineHeight": "--themeTypographyCopySmallLineHeight",
  "theme.typography.copy.small.letterSpacing": "--themeTypographyCopySmallLetterSpacing",
  "theme.typography.copy.large.fontFamily": "--themeTypographyCopyLargeFontFamily",
  "theme.typography.copy.large.fontSize": "--themeTypographyCopyLargeFontSize",
  "theme.typography.copy.large.fontWeight": "--themeTypographyCopyLargeFontWeight",
  "theme.typography.copy.large.lineHeight": "--themeTypographyCopyLargeLineHeight",
  "theme.typography.copy.large.letterSpacing": "--themeTypographyCopyLargeLetterSpacing",
  "theme.typography.copy.bold.fontWeight": "--themeTypographyCopyBoldFontWeight",
  "theme.typography.link.fontWeight": "--themeTypographyLinkFontWeight",
  "theme.typography.heading.2xl.fontFamily": "--themeTypographyHeading2xlFontFamily",
  "theme.typography.heading.2xl.fontSize": "--themeTypographyHeading2xlFontSize",
  "theme.typography.heading.2xl.fontWeight": "--themeTypographyHeading2xlFontWeight",
  "theme.typography.heading.2xl.lineHeight": "--themeTypographyHeading2xlLineHeight",
  "theme.typography.heading.2xl.letterSpacing": "--themeTypographyHeading2xlLetterSpacing",
  "theme.typography.heading.2xl.textTransform": "--themeTypographyHeading2xlTextTransform",
  "theme.typography.heading.xl.fontFamily": "--themeTypographyHeadingXlFontFamily",
  "theme.typography.heading.xl.fontSize": "--themeTypographyHeadingXlFontSize",
  "theme.typography.heading.xl.fontWeight": "--themeTypographyHeadingXlFontWeight",
  "theme.typography.heading.xl.lineHeight": "--themeTypographyHeadingXlLineHeight",
  "theme.typography.heading.xl.letterSpacing": "--themeTypographyHeadingXlLetterSpacing",
  "theme.typography.heading.xl.textTransform": "--themeTypographyHeadingXlTextTransform",
  "theme.typography.heading.lg.fontFamily": "--themeTypographyHeadingLgFontFamily",
  "theme.typography.heading.lg.fontSize": "--themeTypographyHeadingLgFontSize",
  "theme.typography.heading.lg.fontWeight": "--themeTypographyHeadingLgFontWeight",
  "theme.typography.heading.lg.lineHeight": "--themeTypographyHeadingLgLineHeight",
  "theme.typography.heading.lg.letterSpacing": "--themeTypographyHeadingLgLetterSpacing",
  "theme.typography.heading.lg.textTransform": "--themeTypographyHeadingLgTextTransform",
  "theme.typography.heading.md.fontFamily": "--themeTypographyHeadingMdFontFamily",
  "theme.typography.heading.md.fontSize": "--themeTypographyHeadingMdFontSize",
  "theme.typography.heading.md.fontWeight": "--themeTypographyHeadingMdFontWeight",
  "theme.typography.heading.md.lineHeight": "--themeTypographyHeadingMdLineHeight",
  "theme.typography.heading.md.letterSpacing": "--themeTypographyHeadingMdLetterSpacing",
  "theme.typography.heading.md.textTransform": "--themeTypographyHeadingMdTextTransform",
  "theme.typography.heading.sm.fontFamily": "--themeTypographyHeadingSmFontFamily",
  "theme.typography.heading.sm.fontSize": "--themeTypographyHeadingSmFontSize",
  "theme.typography.heading.sm.fontWeight": "--themeTypographyHeadingSmFontWeight",
  "theme.typography.heading.sm.lineHeight": "--themeTypographyHeadingSmLineHeight",
  "theme.typography.heading.sm.letterSpacing": "--themeTypographyHeadingSmLetterSpacing",
  "theme.typography.heading.sm.textTransform": "--themeTypographyHeadingSmTextTransform",
  "theme.typography.heading.xs.fontFamily": "--themeTypographyHeadingXsFontFamily",
  "theme.typography.heading.xs.fontSize": "--themeTypographyHeadingXsFontSize",
  "theme.typography.heading.xs.fontWeight": "--themeTypographyHeadingXsFontWeight",
  "theme.typography.heading.xs.lineHeight": "--themeTypographyHeadingXsLineHeight",
  "theme.typography.heading.xs.letterSpacing": "--themeTypographyHeadingXsLetterSpacing",
  "theme.typography.heading.xs.textTransform": "--themeTypographyHeadingXsTextTransform"
};